import { LayoutTabs } from '../index.d'

export default [{
  label: 'Default',
  key: 'default',
  body: {
    lg: [
      { i: 'w-1-note', x: 0, y: 0, w: 4, h: 5, minW: 4, maxW: 6, minH: 5, maxH: 999 },
      { i: 'w-2-smiley', x: 4, y: 0, w: 4, h: 5, minW: 2, maxW: 4, minH: 5, maxH: 999 },
      { i: 'w-3-cat', x: 8, y: 0, w: 4, h: 6, minW: 4, maxW: 12, minH: 2, maxH: 999 }
    ],
    md: [
      { i: 'w-1-note', x: 0, y: 0, w: 2, h: 6, minW: 2, maxW: 3, minH: 1, maxH: 999 },
      { i: 'w-2-smiley', x: 2, y: 0, w: 1, h: 6, minW: 1, maxW: 3, minH: 2, maxH: 999 },
      { i: 'w-3-cat', x: 0, y: 3, w: 2, h: 2, minW: 2, maxW: 3, minH: 2, maxH: 999 }
    ],
    sm: [
      { i: 'w-1-note', x: 0, y: 0, w: 1, h: 1, minW: 1, maxW: 1, minH: 1, maxH: 999 },
      { i: 'w-2-smiley', x: 1, y: 0, w: 1, h: 6, minW: 1, maxW: 1, minH: 2, maxH: 999 },
      { i: 'w-3-cat', x: 2, y: 0, w: 1, h: 2, minW: 1, maxW: 1, minH: 2, maxH: 999 }
    ]
  }
}] as LayoutTabs
